export default __webpack_public_path__ + "static/media/mail.6ac62bfa.svg";